export enum VehicleHistoryActionTypes {
    SET_CURRENTVEHICLE = "SET_CURRENTVEHICLE",
    SET_PREVIOUSVEHICLE = "SET_PREVIOUSVEHICLE",
    CLEAR_CURRENTVEHICLE = "CLEAR_CURRENTVEHICLE",
    CLEAR_PREVIOUSVEHICLE = "CLEAR_PREVIOUSVEHICLE"
}

export type TVehicle = IIdEntity | null;

export interface IVehicleHistoryStore {
    currentVehicle: TVehicle;
    previousVehicle: TVehicle;
}